<ng-container *ngIf="c2cDataSource && (scope && scope.claims.length) && customerData">
  <table mat-table [dataSource]="c2cDataSource" class="user-table">

    <ng-container matColumnDef="claim_name">
      <th mat-header-cell *matHeaderCellDef> Name</th>
      <td mat-cell *matCellDef="let c2c">

        <mat-accordion [formGroup]="c2cForm">
          <mat-expansion-panel #panel>

            <mat-expansion-panel-header>
              <mat-panel-title>
                {{getClaimDesc(c2c.claim_name)}}
                <ng-container *ngIf="privateClaim(c2c)">
                  ({{c2c.external_customer_id}})
                  <mat-icon class="small" matTooltip="Mitarbeiter-Zugang">perm_identity</mat-icon>
                </ng-container>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-card-content>
              <app-claim-edit [customerData]="customerData" [expansionPanel]="panel" [c2c]="c2c" [c2cFormGroup]="getClaimForm(c2c)"></app-claim-edit>
            </mat-card-content>

          </mat-expansion-panel>
        </mat-accordion>
      </td>
    </ng-container>

    <tr [style]="{display: 'none'}" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

</ng-container>

<mat-paginator *ngIf="pager.length && pager.length > 5"
               [length]="pager.length"
               [pageSize]="pager.pageSize"
               [pageIndex]="pager.pageIndex"
               [pageSizeOptions]="pageSizeOptions"
               (page)="switchPage($event)">
</mat-paginator>
